var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackgcalicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6865 11.5312L16.9365 9.84375V17.1562",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93848 11.0891C9.16348 10.539 9.39973 9.84375 10.7497 9.84375C12.0997 9.84375 12.4372 10.9688 12.4372 11.5312C12.4372 12.0938 11.8747 13.2188 10.1872 13.2188C11.8747 13.2188 12.4372 14.3438 12.4372 14.9062C12.4372 15.4688 12.0997 16.5938 10.7497 16.5938C9.39973 16.5938 9.16348 15.8985 8.93848 15.3484",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 2.8125V6.1875H6.1875V25.3125H2.8125C2.51413 25.3125 2.22798 25.194 2.017 24.983C1.80603 24.772 1.6875 24.4859 1.6875 24.1875V2.8125C1.6875 2.51413 1.80603 2.22798 2.017 2.017C2.22798 1.80603 2.51413 1.6875 2.8125 1.6875H24.1875C24.4859 1.6875 24.772 1.80603 24.983 2.017C25.194 2.22798 25.3125 2.51413 25.3125 2.8125Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 20.25H25.3125L20.25 25.3125H6.1875",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 25.3125V6.1875H25.3125V20.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackgcalicon);
export default __webpack_public_path__ + "static/media/blackgcalicon.d1671865922499b474053af18e1ff2c4.svg";
export { ForwardRef as ReactComponent };